import '../../../less/ss-common-data.less';
import React, { Component } from 'react';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';
import { Card, Row, Col, Progress } from 'antd';
//import { ErrorModal } from '@bit/ui-common.ui-components/ss-common-data';
import ErrorModal from '../errorHandling/ErrorModal';

export default class Load extends Component {
    constructor(props) { super(props); }

    render() {
        const { elementsLoaded, inError, loaded, total } = this.props.hasCommonDataLoaded;

        if(inError) return (
            <div>
                <Row type='flex' justify='center' align='middle'>
                    <Col span={23}>
                        <ErrorModal
                            inError={true}
                            errorHeader={'Unexpected Error'}
                            errorSubHeader={'Unable to load common resources'}
                            errorDetail={'Essential resources failed to load. Please retry or contact support.'}
                        />
                    </Col>
                </Row>
            </div>
        );

        if(!loaded && !inError) {
            let currentStatus = 100 * (elementsLoaded / (total ? total : 1));

            currentStatus = Math.round(currentStatus);

            return (
                <div className='ss-loading-centered'>
                    <div className='ss-loading-title'>
                        {'Flight Training Security Program (FTSP)'}
                    </div>
                    <Row type='flex' justify='center' align='middle'>
                        <Col span={20}>
                            <div className='ss-loading-box-shadow'>
                                <Row type='flex' justify='center' align='middle' style={{ marginBottom: '4px' }}>
                                    <Col style={{ fontWeight: 'bold', fontSize: '14px', fontStyle: 'italic', fontSize: '15px' }}>
                                        {'Loading...'}
                                    </Col>
                                </Row>
                                <Row type='flex' justify='center' align='middle' style={{ marginBottom: '10px' }}>
                                    <Col style={{ fontSize: '11px', fontStyle: 'italic' }}>
                                        {'Please wait...'}
                                    </Col>
                                </Row>
                                <Row type='flex' justify='center' align='middle'>
                                    <Progress percent={currentStatus}/>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </div>
            );
        } else return null
    }
}
